class STransmission implements App.Car.Transmission {
  public id: number;
  public name: string;
  public gearsNumber: number;

  constructor(data?: any) {
    this.id = 0;
    this.name = "";
    this.gearsNumber = 0;
    data && this.init(data);
  }

  private init(data: any) {
    try {
      this.id = data.id || 0;
      this.name = data.name || "";
      this.gearsNumber = data.gears_number || 0;
    } catch {}
  }
}

export default STransmission;
